import { IProject } from "../../../model/model";

const canSaveProject = (_project: IProject) => {
  return { canSave: true, reason: "" };
};

export default canSaveProject;
